// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { useIncomingPayment,  getCountry } from '@tectonics/prs/incoming-payment';

export function CreditCardHeader(): Node {
  const incomingPayment = useIncomingPayment();
  const country = getCountry(incomingPayment);

  switch (country) {
    case 'br':
      return <BrazilianHeader />;

    case 'ar':
    case 'bo':
    case 'cl':
    case 'co':
    case 'ec':
    case 'mx':
    case 'pe':
    case 'uy':
    case 'py':
    case 'pa':
    case 'cr':
    case 'sv':
    case 'gt':
    case 'do':
      return <SpanishHeader />;

    case 'ke':
    case 'ng':
    case 'za':
    case 'eg':
    case 'in':
      return <EnglishHeader />;

    default:
      throw new Error(`PE Payment Header: country ${country} is not supported`);
  }
}

function BrazilianHeader(): Node {
  return (
    <Root>
      Recebemos o seu pedido e estamos analisando a sua solicitação. :)
    </Root>
  );
}

function SpanishHeader(): Node {
  return (
    <Root>
      Su pago está en proceso de confirmación.
    </Root>
  );
}

function EnglishHeader(): Node {
  return (
    <Root>
      Your payment is being processed.
    </Root>
  );
}

const Root = styled.h1`
  text-align: center;
  font-family: ${props => props.theme.fontFamily.display};
  font-weight: 200;
  font-size: 1.4em;
  line-height: 1.5;
  color: ${props => props.theme.colors.primary(39)};
  background-color: ${props => props.theme.colors.gray(96)};
  padding: 16px 32px;

  @media (min-width: 840px) {
    font-size: 2em;
    color: inherit;
    background-color: transparent;
    padding: 32px;
  }
`;
